import { useEffect, useState } from 'react';
import { Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { observer } from 'mobx-react-lite';

import { useResource } from 'app/common/api';
import { usePageNotify } from 'app/common/notifications/features/page-notifications';
import { Loading } from 'app/ui';

import { TRoute } from '../../core/route';
import {
  TRouteStation,
  TRouteStationZoneGrid,
} from '../../core/route-station-zones';
import { getRouteStationDetailsRequest } from '../../requests/get-route-station-details.request';
import { createTableHoverCss } from './create-table-hover-css';
import { createZoneStationDataMap } from './create-zone-station-data-map';

type ZoneStationGridProps = {
  routeId: number;
};

export const ZoneStationGrid = observer(({ routeId }: ZoneStationGridProps) => {
  const [stateData, setStateData] = useState<{
    rows: TRouteStation[];
    cols: ColumnsType<TRouteStation>;
  }>({ cols: [], rows: [] });
  const pageNotify = usePageNotify();

  const getRouteStationDetailsResource = useResource<
    TRoute['id'],
    TRouteStationZoneGrid
  >({
    request: getRouteStationDetailsRequest,
    errorNotify: pageNotify,
    onDone: (stationZones) => {
      const stationZonesDataMap = createZoneStationDataMap(stationZones);

      setStateData(stationZonesDataMap);
    },
  });

  useEffect(() => {
    getRouteStationDetailsResource.send(routeId);
  }, [routeId]);

  useEffect(() => {
    return createTableHoverCss({
      tableSelector: '.table',
      firstColumnPosition: 1,
      lastColumnPosition: stateData.rows.length,
    });
  }, [stateData.rows.length]);

  return (
    <Loading active={getRouteStationDetailsResource.isLoading}>
      <Table
        className="table"
        rowKey={(row) => row.station.id}
        columns={stateData.cols}
        dataSource={stateData.rows}
        size="small"
        bordered
        pagination={false}
      />
    </Loading>
  );
});
